import { useEffect } from 'react';
import { connect } from 'dva';
import PropTypes from 'prop-types';
import Graphic from '@arcgis/core/Graphic';
import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';
import PictureMarkerSymbol from '@arcgis/core/symbols/PictureMarkerSymbol';
import Search from '@arcgis/core/widgets/Search';

import { getItemIndex } from '../../../lib/utils';
import { MAP_LAYER_IDS } from '../../../lib/constants';
import actions from './actions';
import ghAnalytics from '../../../lib/analytics';
import searchIcon from '../../../assets/svg/search-grey.svg';

function GHSearch(props) {
  useEffect(() => {
    if (props.view.ui.find('search') != null) {
      return;
    }

    if (props.isUpdatingLocation) return;
    const searchWidget = new Search({
      id: 'search',
      viewModel: {
        view: props.view,
      },
      resultGraphicEnabled: false,
      popupEnabled: false,
    });

    const resultListener = searchWidget.on('select-result', (e) => {
      const { result } = e;
      const { feature } = result;

      const graphicSymbol = new PictureMarkerSymbol({
        // url: svgToDataURI(searchIcon),
        url: searchIcon,
        width: '34px',
        height: '42px',
        yoffset: '21px',
      });

      const searchGraphic = new Graphic({
        attributes: { id: 'search-point' },
        geometry: {
          type: 'point',
          latitude: feature.geometry.latitude,
          longitude: feature.geometry.longitude,
        },
        symbol: graphicSymbol,
      });

      props.addSearchGraphicToMap(searchGraphic);
    });

    const clearListener = searchWidget.on('search-clear', (e) => {
      props.clearSearchLayer();
    });

    const startListener = searchWidget.on('search-start', (e) => {
      props.clearSearchLayer();
    });

    const completeListener = searchWidget.on('search-complete', (e) => {
      ghAnalytics.logMapSearchUsed(e.searchTerm);
    });

    const searchLayerIndex = getItemIndex({
      items: props.map.layers.items,
      key: 'id',
      reverse: true,
      value: MAP_LAYER_IDS.search
    })
    if (searchLayerIndex === -1) {
      const newSearchLayer = new GraphicsLayer({
        id: MAP_LAYER_IDS.search,
        mode: 'on-the-ground',
      });

      props.map.add(newSearchLayer);
    }

    props.view.ui.add(searchWidget, 'top-right');

    return () => {
      resultListener.remove();
      clearListener.remove();
      startListener.remove();
      completeListener.remove();
      props.view.ui.remove(searchWidget);
      // Destroy the widget so it tears down its own internal handlers/graphics
      // instead of leaving them orphaned on every view recreation.
      searchWidget.destroy();
    };
  }, [props.view, props.isUpdatingLocation]);

  return null;
}

GHSearch.propTypes = {
  addSearchGraphicToMap: PropTypes.func,
  clearSearchLayer: PropTypes.func,
  isUpdatingLocation: PropTypes.bool,
  map: PropTypes.object,
  view: PropTypes.object
};

export default connect((model) => {
  return {
    isUpdatingLocation: model.map.isUpdatingLocation,
  };
}, actions)(GHSearch);
